import { useEffect } from 'react';
import { motion } from 'framer-motion';
import HeroSection from '../components/HeroSection';
import USPSection from '../components/USPSection';
import ReferenceSection from '../components/ReferenceSection';
import LeadFormSection from '../components/LeadFormSection';
import ProcessSection from '../components/ProcessSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import { useCookieConsent } from '../context/CookieConsentContext';

const LandingPage = () => {
  const { trackEvent } = useCookieConsent();

  useEffect(() => {
    // Track ViewContent on page load (after consent check)
    trackEvent('ViewContent', { content_name: 'Landing Page' });
  }, [trackEvent]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="min-h-screen bg-dark"
      data-testid="landing-page"
    >
      <HeroSection />
      <USPSection />
      <ReferenceSection />
      <LeadFormSection />
      <ProcessSection />
      <FAQSection />
      <Footer />
    </motion.div>
  );
};

export default LandingPage;
